import { render } from "./TranslateMenu.vue?vue&type=template&id=d3328508&scoped=true&ts=true"
import script from "./TranslateMenu.vue?vue&type=script&lang=ts"
export * from "./TranslateMenu.vue?vue&type=script&lang=ts"

import "../assets/scss/translate-menu.scss?vue&type=style&index=0&id=d3328508&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3328508"]])

export default __exports__